<template>
    <div class="google-map">
        <GoogleMapLoader
            v-if="renderComponent"
            :mapConfig="mapConfig"
            apiKey="AIzaSyD5dh-rbU9bTRSe4rYgbC8pCoiqKk56cTI"
            :heatMap="heatMapUrl"
            :project="project"
        >
            <template slot-scope="{ google, map, bounds }">
                <GoogleMapMarker
                    v-for="marker in devices"
                    :key="marker._id"
                    :marker="marker"
                    :label="marker.name"
                    :google="google"
                    :map="map"
                    :bounds="bounds"
                    :googleMapMarkers="googleMapMarkers"
                    :numberMarks="devices.length"
                    @selectMarker="selectMarker(...arguments)"
                />
            </template>
        </GoogleMapLoader>
        <v-overlay
            :absolute="true"
            :value="overlay"
            :dark="false"
        >
            <v-card
                class="ma-3"
                max-width="300"
                min-width="300"
            >
                <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="headline">
                        {{deviceInfo.name}}
                        <v-icon
                            v-show="isDisconnected && false"
                            color="red darken-2"
                        >
                            mdi-lan-disconnect
                        </v-icon>
                        
                        <v-btn
                            class="float-md-right"
                            @click="overlay = false"
                            icon
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{deviceInfo.ts | dateFormat}}</v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-card-actions >
                    <v-row align="center" justify="center">
                        <v-btn text @click="goSensor(deviceInfo.deviceId)" v-show="false"> Sensor </v-btn>
                        <v-btn text @click="goLaeq(deviceInfo.deviceId)" :disabled="!hasLaeq(deviceInfo.deviceId)"> Sonido </v-btn>
                        <v-btn text disabled> Log </v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
	import moment from 'moment'
    import GoogleMapLoader from '@/components/GoogleMap/GoogleMapLoader'
    import GoogleMapMarker from '@/components/GoogleMap/GoogleMapMarker'
    import { mapSettings } from '@/constants/mapSettings.js'

    export default {
        props: {
            heatMap: Boolean
        },
        data: () => ({
            googleMapMarkers: [],
            overlay: false,
            selectDevice: null,
            isDisconnected: false,
            deviceInfo: {
                name: '',
                deviceId: ''
            },
            renderComponent: false,
            center: {
                lat: -36.835939888115604,
                lng: -73.07160263961296
            },
            heatMapUrl: ''
        }),
        
        computed: {
            mapConfig () {
                return {
                    ...mapSettings,
                    center: this.center
                }
            },
            
            devices () {
				return this.$store.getters.devices.filter( e => {
                    return e.projectId == this.project && Object.hasOwnProperty.call(e, "location")
                })
            },

            project () {
                return this.$store.getters.project
            },
            
            projects () {
                return this.$store.getters.projects
            },

            projectInfo () {
                return this.projects.find(e => e.projectId === this.project)
            }
        },

        methods: {
            selectMarker(marker, googleMarker) {
                this.goLaeq(marker.deviceId)
            },

            goSensor (id) {
				this.$router.push('/sensor/' + id)
			},

			goLaeq (id) {
				this.$router.push('/laeq/' + id)
            },
            
            hasLaeq (id) {
                return this.$store.getters.devicesHasLaeq(id)
			},

            getCenter ( data ) {
                let sumLat = 0, sumLng = 0
                const initProject = data[0].projectId
                const centerProject = this.project === 'all' ? initProject : this.project

                let deviceProject = data.filter(e => {
                    return e.projectId === centerProject
                })

                for (let i = 0; i < deviceProject.length; i++) {
                    const element = deviceProject[i]
                    sumLat += element.location.lat
                    sumLng += element.location.lng
                }

                if (deviceProject.length > 0)
                    this.renderComponent = true

                this.center = {
                    lat: deviceProject.length > 0 ? sumLat / deviceProject.length : 0,
                    lng: deviceProject.length > 0 ? sumLng / deviceProject.length : 0
                }
            }
        },

        watch: {
            devices (val) {
                this.getCenter( val )

                if ( this.heatMap && this.projectInfo.info !== undefined )
                    this.heatMapUrl = this.projectInfo.info.kml
            },

            project () {
                this.googleMapMarkers = []
            }
        },

        filters : {
			dateFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LLL')
			},
        },
        
        components: {
            GoogleMapLoader,
            GoogleMapMarker
        },

        created () {
            moment.locale('es-us')

            if ( this.heatMap && this.projectInfo.info !== undefined )
                this.heatMapUrl = this.projectInfo.info.kml

            this.getCenter (this.devices)

            this.bounds = new google.maps.LatLngBounds()
        },
    }
</script>